import { render, staticRenderFns } from "./AlphaRegistration.vue?vue&type=template&id=1202a111"
import script from "./AlphaRegistration.vue?vue&type=script&lang=js"
export * from "./AlphaRegistration.vue?vue&type=script&lang=js"
import style0 from "./AlphaRegistration.vue?vue&type=style&index=0&id=1202a111&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports